/** Stable HTML data attributes for CTA click tracking (see CtaClickTracker). */
export type CtaTrackingProps = {
	ctaId: string;
	ctaName: string;
	ctaLocation: string;
	linkUrl?: string;
};

export function getCtaDataAttrs({
	ctaId,
	ctaName,
	ctaLocation,
	linkUrl,
}: CtaTrackingProps): Record<string, string> {
	return {
		"data-cta-id": ctaId,
		"data-cta-name": ctaName,
		"data-cta-location": ctaLocation,
		...(linkUrl ? { "data-cta-url": linkUrl } : {}),
	};
}
